import type React from 'react';
import Upsell from './Upsell';
import type { UpsellGroupProps } from '../../Store/Upsell/state';
import styles from './UpsellGroup.module.scss';

interface Props {
    parentCartItemId: number;
    parentProductId: number;
    upsellGroup: UpsellGroupProps;
}

const UpsellGroup: React.FC<Props> = ({ parentCartItemId, parentProductId, upsellGroup }) => (
    <div className={styles.UpsellGroup}>
        { upsellGroup.products.map((upsellProduct) => <Upsell
            hasSiblings={ upsellGroup.products.length > 1 }
            key={ upsellProduct.id }
            upsellProduct={ upsellProduct }
            upsellGroupId={ upsellGroup.id }
            parentCartItemId={ parentCartItemId }
            parentProductId={ parentProductId }
        />) }
    </div>
);

export default UpsellGroup;
